


















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FeedSection from "@/components/FeedSection.vue";
import { FeedPage, LoadPageAction } from "@/store/feed";

const { State, Action } = namespace("feed");

// 48 items evenly divide into 2, 3, and 4 columns
const PAGE_SIZE = 48;

// five minutes
const REFRESH_INTERVAL = 1_000 * 60 * 5;

@Component({
  components: { FeedSection }
})
export default class Feed extends Vue {
  refreshInterval = -1;

  @State pages!: FeedPage[];
  @Action loadPage!: (payload: LoadPageAction) => Promise<void>;

  created() {
    this.loadPage({ pageSize: PAGE_SIZE, pageNumber: 1 });
    this.refreshInterval = setInterval(
      () => this.loadPage({ pageSize: PAGE_SIZE, pageNumber: 1 }),
      REFRESH_INTERVAL
    );
  }

  beforeDestroy() {
    clearInterval(this.refreshInterval);
  }

  refresh(pageNumber: number) {
    this.loadPage({ pageSize: PAGE_SIZE, pageNumber });
  }
}
